/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Card_On_FileInputs */



/**
* | output |
* | --- |
* | "No card on file" |
*
* @param {No_Card_On_FileInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const no_card_on_file = /** @type {((inputs?: No_Card_On_FileInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Card_On_FileInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucune carte enregistrée")
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine Karte hinterlegt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessuna carta in archivio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Карта не сохранена.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No hay ninguna tarjeta en el archivo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("未登记银行卡")
	if (locale === "ja") return /** @type {LocalizedString} */ ("カードが登録されていません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोई कार्ड रिकॉर्ड में नहीं है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhum cartão cadastrado")
	return /** @type {LocalizedString} */ ("No card on file")
});